import {getRouting} from '@shared/functions/get-routing.function';
import {environment} from '@env';

/**
 * Funkcja zwracająca przeformatowany adres API.
 * @param endpoint - adres url punktu końcowego API w postaci niesformatowanej, np.: /users/:id
 * @param params - parametry dla adresu API np.: ['100'] => /users/100.
 */
export const getEndpoint = (endpoint: string, params: string[] = []): string => {
  const pathname: string = getRouting(endpoint, params);

  return `${environment.API_HOST_URL}/${pathname}`;
};
